import { FC, useState } from 'react';

import { Button, Heading, NotificationBox, RadioGroup, RadioTile, Stack, Stretch } from '@eneco/sparky';
import { House, SmallBusiness } from '@eneco/sparky/illustrations';
import { NotificationBarProps } from '@eneco/sparky/types';
import { useTracking } from '@eneco/tracking';
import { useContent } from '@sitecore/common';
import { PriceSimulationRenderingExtended } from '@sitecore/types/manual/be/PriceSimulationExtended';
import { Controller, useFormContext } from 'react-hook-form';

import { PriceSimulationFormSchema } from '../schemas/priceSimulationFormSchema';
import { FlowChildProps } from '../types/PriceSimulationSteps';
import { getTrackableFormValues } from '../utils/getTrackableFormValues';

export const CustomerTypeStep: FC<FlowChildProps> = ({ nextMainStep }) => {
  const { fields } = useContent<PriceSimulationRenderingExtended>();
  const { control, getValues } = useFormContext<PriceSimulationFormSchema>();
  const { trackEventBE } = useTracking();

  const [error, setError] = useState<NotificationBarProps | null>(null);

  const onNextClick = () => {
    if (getValues('customerType') === undefined) {
      setError({
        variant: 'error',
        title: fields.summaryStep.errorNotification.value.title,
        text: fields.addressTypeSelectionStep.addressTypesList.value.requiredMessage,
      });
      return;
    }
    trackEventBE('pbt_start', {
      status: 'click',
      data: getTrackableFormValues(getValues()),
    });

    nextMainStep();
  };

  return (
    <>
      <Heading as="h1" size="M">
        {fields.addressTypeSelectionStep.title.value}
      </Heading>
      <Stretch>
        <div>
          <Controller
            control={control}
            name="customerType"
            render={({ field: { onChange, value } }) => (
              <RadioGroup
                name="customerType"
                aria-labelledby={fields.addressTypeSelectionStep.addressTypesList.value.label}
                direction="column"
                value={value}
                onValueChange={onChange}>
                {fields.addressTypeSelectionStep.addressTypesList.value.options.map(option => (
                  <RadioTile
                    icon={option.name === 'Residential' ? <House size={'small'} /> : <SmallBusiness size={'small'} />}
                    value={option.name}
                    key={option.name}>
                    {option.label}
                  </RadioTile>
                ))}
              </RadioGroup>
            )}
          />
        </div>
      </Stretch>
      {error && <NotificationBox variant="error" isAlert {...error} />}
      <Stack gap="2" direction="row">
        <Button onClick={onNextClick}>{fields.navigation.nextButtonText.value}</Button>
      </Stack>
    </>
  );
};
